import { IntelligencePanel } from "../components/IntelligencePanel";

export function IntelligencePage() {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl font-bold tracking-tight">Intelligence</h1>
      <IntelligencePanel />
    </div>
  );
}
